     <!--begin::Stat-->
     <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6">
      <!--begin::Number-->
      <div class="d-flex align-items-center">
          <div class="fs-4 fw-bold">{{value}}</div>
      </div>
      <!--end::Number-->

      <!--begin::Label-->
      <div class="fw-semibold fs-6 text-gray-400">{{title}}</div>
      <!--end::Label-->
  </div>
  <!--end::Stat-->
